/* global angular */
import './style.less';
export default function($scope, $q, $window, UserClass) {
  'ngInject';
  $scope.hideMobile = 'hidden-xs hidden-sm';
  $scope.hideNormal = 'hidden-md hidden-lg';

  const w = angular.element($window);

  $scope.loggedIn = UserClass.userStatus;

  $scope.$watch(
    () => {
      return $window.innerWidth;
    },
    val => {
      $scope.windowWidth = val;
    },
    true
  );
  w.bind('resize', () => {
    $scope.$apply();
  });
}



// WEBPACK FOOTER //
// ./src/app/controllers/application/controller.js